import script from "./VehicleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleCard.vue?vue&type=script&setup=true&lang=js"

import "./VehicleCard.vue?vue&type=style&index=0&id=1755a60b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1755a60b"]])

export default __exports__